import { ECoverageAreaType } from "enums/options/coverageArea";

import { CoverageAreaDealer, CoverageAreaProps } from "./types.store";

type CoverageAreaDealerSource =
  | Pick<CoverageAreaProps, "dealer">
  | null
  | undefined;

export function getCoverageAreaDealerId(
  area: CoverageAreaDealerSource,
): string {
  return area?.dealer?.id ?? "";
}

export function buildLogisticsDealerPayload(
  dealer: CoverageAreaDealer,
): CoverageAreaDealer {
  return {
    id: dealer.id,
    enabled: dealer.enabled,
  };
}

export function normalizeCoverageAreaFromApi(
  coverageArea: CoverageAreaProps,
): CoverageAreaProps {
  return {
    ...coverageArea,
    dealer: buildLogisticsDealerPayload(coverageArea.dealer),
  };
}

export function buildLogisticsCoverageAreaBody(
  area: CoverageAreaProps,
): CoverageAreaProps {
  return {
    ...area,
    dealer: buildLogisticsDealerPayload(area.dealer),
  };
}

export function supportsCoverageAreaDriverRegistration(
  type?: ECoverageAreaType,
): boolean {
  return (
    type === ECoverageAreaType.DealerMap ||
    type === ECoverageAreaType.DriverStore
  );
}
